module.exports = __webpack_public_path__ + "img/61.5.COD.7a52ee11.png";